/**
 * Configuracion del mecanismo de reintento automatico para el error
 * PNR ACTIVITY IN PROGRESS (3060). Centralizada para ajustar valores
 * sin tocar la logica de retry.
 */
export const RETRY_CONFIG = {
  PNR_ACTIVITY: {
    /** Maximo de reintentos adicionales despues del primer intento fallido */
    maxRetries: 3,
    /** Espera en milisegundos entre cada reintento */
    delayMs: 2000,
    /** Codigo de error/warning que dispara el retry */
    errorCode: '3060',
    /** Mensaje de warning alterno que tambien identifica el 3060 (alineado con getWarning) */
    errorMessage: '!PNR ACTIVITY IN PROGRESS',
  },
} as const;

/**
 * CI-23238: aviso que indica que el pasajero ya figura en la lista de espera.
 * Permite reconocerlo por codigo (preferido, cuando backend lo exponga) o por
 * texto (respaldo confirmado en New Relic: !PASSENGER ALREADY ON PRIORITY LIST).
 */
export const ALREADY_ON_PRIORITY_LIST = {
  code: '',
  errorMessage: 'ALREADY ON PRIORITY LIST',
} as const;
